import { render } from "./AustraliaAmlCtfDownload.vue?vue&type=template&id=34f62d0b"
import script from "./AustraliaAmlCtfDownload.vue?vue&type=script&lang=js"
export * from "./AustraliaAmlCtfDownload.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__